<template>
  <div class="homePage dflex fdcolumn">
    <div class="mt80">
      <img src="@/image/nqyjk/topTxt.png" mode="widthFix" style="width: 80%;margin: 0 auto;display: block;">
    </div>

    <div class="homeMeunBg mt40">
      <div class="homeMeun dflex atem jbetween" :class="disMeunBg ? 'bhb' : ''">
        <div class="li" :class="tabIndex == index ? 'ac' : ''" v-for="(item, index) in meunList" :key="index"
          @click="tabFun1(item, index)">
          <div>{{ item.txt }}</div>
        </div>
      </div>

    </div>

    <div class="pr mt20">
      <div v-if="tabIndex == 0">
        <div class="dflex jtem">
          <div class="tittle">公司背景</div>
        </div>
        <div class="content mt20">
          <img src="@/image/nqyjk/1.png" mode="widthFix" style="width: 100%;">
        </div>
        <div class="dflex jtem mt20">
          <div class="tittle">产品介绍</div>
        </div>
        <div class="content mt20">
          <img src="@/image/nqyjk/2.png" mode="widthFix" style="width: 100%;">
        </div>
        <div class="dflex jtem mt20">
          <div class="tittle">运营推广</div>
        </div>
        <div class="content mt20">
          <img src="@/image/nqyjk/3.png" mode="widthFix" style="width: 100%;">
        </div>
      </div>

      <div v-else-if="tabIndex == 1">
        <div class="content">
          <div class="video-box">
            <video src="@/image/nqyjk/逆转糖尿病小.mp4" controls autoplay loop muted x5-video-player-fullscreen="true" webkit-playsinline="true" x-webkit-airplay="true" playsinline="true" x5-playsinline class="my-video"></video>
          </div>
        </div>
      </div>

      <div v-else>
        <div class="content">
          <div class="video-box">
            <video src="@/image/nqyjk/调降高血脂小.mp4" controls autoplay loop muted x5-video-player-fullscreen="true" webkit-playsinline="true" x-webkit-airplay="true" playsinline="true" x5-playsinline class="my-video"></video>
          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import { Row, Col, Icon, Cell, CellGroup, ImagePreview } from 'vant';
import { Shares } from '@/js/share'
export default {
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [ImagePreview.Component.name]: ImagePreview.Component,
  },
  data() {
    return {
      nowRoute: '',
      tabIndex: 0,
      disMeunBg:false,
      meunTop: 0,
      meunList: [{
        txt: '合作推广介绍'
      },
      {
        txt: '逆转糖尿病'
      },
      {
        txt: '调降高血脂'
      }
      ],
      videoCssObj: {
        width: 0,
        height: 0
      },
    }
  },
  watch: {

  },
  mounted() {
    window.addEventListener('scroll', this.scrollSet);

    let imgurl = 'https://xztys.goldweb.cn/img/shareImg.jpg'
    let title = '年轻源慢病健康管理推广介绍'
    let desc = '年轻源是一家专注于慢病健康管理领域的高科技企业，聚焦糖尿病、高脂血症等'
    let link = 'http://xztys.goldweb.cn/#/nqyjkIndex'

    // console.log(imgurl, title, desc, link)
    Shares.shareCode(imgurl, title, desc, link, (status, data) => {
      if (status === 'success') {
        console.log('success')// 分享成功的操作
      } else if (status === 'cancel') {
        console.log('error')// 分享失败的操作
      }
    })

    this.getElementTopDistance();
  },
  methods: {
    tabFun1(data, index) {
      this.tabIndex = index
    },
    getElementTopDistance() {
      let that = this
      let element = document.querySelector('.homeMeun');
      that.meunTop = element.offsetTop+100;
      console.log(that.meunTop)
    },
    scrollSet() {
      let that = this
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      // console.log(scrollTop)
			if (scrollTop >= that.meunTop) {
				that.disMeunBg = true
			} else {
				that.disMeunBg = false
			}
    }
  },
  destroyed() {
    window.removeEventListener('scroll', this.scrollSet)
  }
};
</script>
<style scoped>
 @import url("~@/assets/css/style.css");
</style>
<style lang="less" scoped>

</style>